import Vue from 'vue'
import axios from 'axios';
import qs from "qs";
// import router from '@/router'
import Router from '@/router/index'
import { Message, MessageBox } from 'element-ui';
import Bus from "@/util/Bus.js";

function getCookie(cookName) {

    var cookieStr = document.cookie.split(";");

    for (var i = 0; i < cookieStr.length; i++) {

        var val = cookieStr[i].split("=");

        if (escape(cookName) == val[0].replace(/\s*/g, ""))
            return unescape(val[1]);
    }
    return null;
}
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}
function delCookie(name) {
    setCookie(name, "", -1);
}
axios.interceptors.request.use(config => {
    // let {isLogin, header = {}, params = {}, data = {}, url} = config;
    //console.log(config.url)
    // config.url += basePath;
    // 正对get方法序列化
    if (config.method === 'get') {
        config.paramsSerializer = function (params) {
            return qs.stringify(params, { arrayFormat: 'repeat' })
        }
    }
    // console.log("request config", config)
    let cookie = getCookie('cloud_token');
    if (cookie) {
        config.headers['X-AUTH-TOKEN'] = cookie;
    } else {
        // Router.push('login')
    }
    //    config.data = Object.assign(config.data,authConfig)
    return config;
}, (error) => {
    return Promise.reject(error);
});


function isBlob(data) {
    return typeof Blob !== 'undefined' && data instanceof Blob
}

function readBlobAsText(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsText(blob)
    })
}

function pickResponseMessage(data) {
    if (!data) {
        return ''
    }
    if (typeof data === 'string') {
        try {
            data = JSON.parse(data)
        } catch (e) {
            return data
        }
    }
    if (isJson(data)) {
        return data.msg || data.message || data.detail || data.error || ''
    }
    return ''
}

function getResponseMessage(data) {
    if (isBlob(data)) {
        return readBlobAsText(data).then(text => pickResponseMessage(text))
    }
    return Promise.resolve(pickResponseMessage(data))
}

axios.interceptors.response.use((response) => {
    let { data, config, headers, status } = response;
    let ct = headers['content-type'] || ''
    let cd = headers['content-disposition']
    if (ct.includes('application/vnd.') || ct.includes('application/zip')) {
        //导出的
        let fileName = ''
        if (!isEmpty(cd)) {
            fileName = cd.split(";")[1].split("filename=")[1]
        }
        var blob = new Blob([data], { type: ct })
        var downloadElement = document.createElement('a');
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = fileName; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
        return response.data
    }
    if (typeof data === 'string') {
        return data;
    }
    if (isBlob(data)) {
        return getResponseMessage(data).then(message => Promise.reject(message || '导出失败'))
    }
    if (data.code != 0) {
        return Promise.reject(data.msg)
    }
    return response.data;
}, (error) => {
    if (!error.response) {
        return Promise.reject(error)
    }
    if (error.response.status == 401) {
        MessageBox.alert('登录已失效，请重新登录', '提示', {
            confirmButtonText: '确定',
            callback: function () {
                delCookie('cloud_token');
                localStorage.removeItem('userInfo')
                localStorage.removeItem('activeTab')
                Bus.$emit('logout')
                Router.push({ path: '/login' }, () => { })
            }
        })
    } else {
        return getResponseMessage(error.response.data).then(message => {
            const errorMessage = message || error.response.statusText
            Message({
                message: errorMessage,
                type: 'error',
                showClose: true,
                center: true
            })
            const requestError = new Error(errorMessage)
            requestError.messageShown = true
            return Promise.reject(requestError)
        })
        // console.error(error.response.statusText)
    }
    // return Promise.reject(new Error('登录失效'));

})
/**!
 * 是否为JSON字符串
 */
function isJson(obj) {
    return typeof (obj) === 'object' && Object.prototype.toString.call(obj).toLowerCase() === '[object object]' && !obj.length
}

/**!
 * 是否为空
 */
function isEmpty(obj) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
        return true
    }
    if (isJson(obj)) {
        for (let i in obj) {
            return false
        }
        return true
    }
    if (Array.isArray(obj) && obj.length < 1) {
        return true
    }
    return false
}
export { axios }



// WEBPACK FOOTER //
// ./src/util/axios.js